import axios from "axios";
import { getBackendBaseURL } from "./axios";
import { authenticate } from "./utils/firebase";

const customClientAxios = () => {
  const axiosInstance = axios.create({ baseURL: getBackendBaseURL() });

  axiosInstance.interceptors.request.use(
    async (config) => {
      const user = authenticate.currentUser;
      if (user) {
        try {
          const token = await user.getIdToken();
          config.headers["authorization"] = `Bearer ${token}`;
        } catch {
          // Token fetch failed — request will go without auth
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        // Try refreshing the token once
        const user = authenticate.currentUser;
        if (user && !error.config._retry) {
          error.config._retry = true;
          try {
            const newToken = await user.getIdToken(true);
            error.config.headers["authorization"] = `Bearer ${newToken}`;
            return axiosInstance(error.config);
          } catch {
            window.location.href = "/";
          }
        } else {
          window.location.href = "/";
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default customClientAxios;
